import { useEffect } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../services/hooks/useReduxHooks";
import { closeGlobalSnackBar } from "../../../services/redux/slices/globalComponentsToggleSlice";
import styles from "./Snackbar.module.scss";

export default function SnackBar() {
  const dispatch = useAppDispatch();
  const globalSnackBar = useAppSelector(
    (state) => state.globalComponentsToggleSlice.globalSnackBar
  );

  useEffect(() => {
    setTimeout(() => {
      dispatch(closeGlobalSnackBar());
    }, 5000);
  }, []);

  const message = (
    <p className={styles.snackbar_item_name}>
      <span>{globalSnackBar.text}</span>
    </p>
  );

  return (
    <>
      {globalSnackBar.isOpen && (
        <div className={styles.snackbar_wrapper}>
          <div className={styles.add_to_cart_snak_bar}>{message}</div>
        </div>
      )}
    </>
  );
}
